const getMonthlyIncome = (source, useGrossIncome, defaultMultiplier = 1) => {
  const monthlyIncome = source.monthlyIncome ?? 0;
  const grossMultiplier = source.gross_income_multiplier ?? defaultMultiplier;
  return useGrossIncome ? monthlyIncome * grossMultiplier : monthlyIncome;
};

export default getMonthlyIncome;
